import { LoadingStatus } from '../types'

export enum MchatSteps {
  Initial,
  ParentInfo,
  ChildInfo,
  ReviewInfo,
  Questions,
  Result
}

interface MchatFlowData {
  currentStep: MchatSteps
}

export interface Answer {
  id: string
  answer: boolean
}

export interface MchatInputData {
  parentFullName?: string
  email?: string
  phone?: string
  childName?: string
  childDob?: string
  currentDate?: string
}

export interface MchatState {
  status: LoadingStatus
  flowData: MchatFlowData
  inputData: MchatInputData
  questions: {
    currentQuestion: number
    score: number
    answers: Answer[]
  }
  error: string
}

export interface NavigationState {
  step: MchatSteps
}

export enum MchatInputFieldsNames {
  parentFullName = 'parentFullName',
  email = 'email',
  phone = 'phone',
  childName = 'childName',
  childDob = 'childDob',
  currentDate = 'currentDate'
}
